<!--  -->
<template>
  <div>
    <!-- <el-input v-model="name" placeholder="输入名称"></el-input>
    <div v-for="(item,index) in customerarr" :key="index" @click="customeclick(item.name,item.id)">
      <div>{{ item.name }}</div>
    </div> -->

    <el-select :value="obj.name" value-key="id" filterable placeholder="请选择" @change="choosechange">
      <el-option
        v-for="item in customerarr"
        :key="item.id"
        :label="item.name"
        :value="item"
      />
    </el-select>
    <div class="get_btn">
      <el-button type="primary" @click="customeclick">确定</el-button>
    </div>

  </div>
</template>

<script>
import { menuRichText } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      obj: {
        name: null,
        id: null
      },
      customerarr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async handcustome() {
      const data = await menuRichText({ name: this.name })
      this.customerarr = data.data
    },
    customeclick() {
      console.log(this.obj.name, this.obj.id)
      this.$emit('customecallback', this.obj.name, this.obj.id)
      this.obj.name = null
    },
    customeoncallback() {
      this.handcustome()
    },
    choosechange(val) {
      console.log(val)
      this.obj.name = val.name
      this.obj.id = val.id
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.get_btn{
  margin-top: 30px;
}
</style>
